module.exports = __webpack_public_path__ + "img/user-group_en.895507ef.png";